// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { SmartTable } from '../../../../components/smart-table/smart-table.model';
import { resolve } from '../../../../init/store';
import { isApproveAvailableForAdmin, prepareWaitingApprovals, requestTypeLabel } from '../request-center.functions';

export class Controller {
    /** @ngInject */
    constructor(RequestCenterService, ShowNoteModal, ConfirmDeleteModal, $state) {
        this.RequestCenterService = RequestCenterService;
        this.ShowNoteModal = ShowNoteModal;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.$state = $state;
    }

    $onInit() {
        resolve.hasRequests = this.hasRequests();
    }

    hasRequests() {
        for(let request of this.requests) {
            if(isApproveAvailableForAdmin(request)) {
                return true;
            }
        }
        return false;
    }

    showNote(requestDto){
        this.ShowNoteModal('Note', requestDto.note);
    }

    approveRequest(requestDto) {
        this.RequestCenterService.approveRequest(this.companyId, requestDto.id)
            .then(() => this.$state.reload('company.request-center'))
    }

    getRequestTypeLabel(requestDto) {
        return requestTypeLabel(requestDto.type);
    }

    denyRequest(requestDto) {
        this.ConfirmDeleteModal('Are you sure you want to deny this request')
            .then(() => {
                this.RequestCenterService.denyRequest(this.companyId, requestDto.id)
                    .then(() => this.$state.reload('company.request-center'))
            })
    }

    getWaitingApprovals(requestDto) {
        return prepareWaitingApprovals(requestDto);
    }

    displayApproveButton(requestDto) {
        return isApproveAvailableForAdmin(requestDto);
    }

    displayDenyButton(requestDto) {
        return isApproveAvailableForAdmin(requestDto);
    }

    deleteRequest(requestDto) {
        this.ConfirmDeleteModal('Are you sure you want to delete this request')
            .then(() => {
                this.RequestCenterService.deleteRequestForCompany(this.companyId, requestDto.id)
                    .then(() => this.$state.reload('company.request-center'));
            })
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/list/request-center-list.controller.js